import { useQuery } from '@tanstack/react-query';

import { Envelope } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapPaginatedResponseDataAs } from '../../../logic/unwrapPaginatedResponseDataAs';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { getEnvelopes } from '../../requests/getEnvelopes';
import { EnvelopesSearchParams } from '../../types/EnvelopesSearchParams';

export const useSignatureEnvelopes = (
  documentId: string,
  searchParams?: EnvelopesSearchParams,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    PaginatedResponse<Envelope[]> | undefined
  >({
    queryKey: [SIGNATURE_BASE_PATH, 'envelopes', documentId, searchParams],
    queryFn: () => getEnvelopes(constructGet, documentId, searchParams),
    keepPreviousData: true,
    staleTime: 10000,
    ...options,
  });

  return {
    ...unwrapPaginatedResponseDataAs(data, refetch, 'envelopes'),
    ...rest,
  };
};
